import { useRef } from 'react';
import { ArcadeShowcase } from '@/components/arcade/arcade-showcase';
import type { ArcadeIntrosOg } from '@/types';

export default function Og({ edition }: ArcadeIntrosOg) {
  const progressRef = useRef(1);

  return (
    // app/(public)/26/arcade/layout.tsx wraps this whole tree in a black page; here the
    // rig's own full-bleed black background is that page.
    <div className="min-h-screen bg-black">
    <div className="flex min-h-dvh w-full items-center justify-center bg-black">
      <div
        style={{
          width: 1200,
          height: 630,
          flexShrink: 0,
          position: 'relative',
          overflow: 'hidden',
          background:
            'radial-gradient(ellipse at 60% 40%, #555555 0%, #333333 45%, #1a1a1a 100%)',
          outline: '2px solid red',
        }}
      >
        <ArcadeShowcase
          scrollProgressRef={progressRef}
          editionSlug={edition.eventSlug}
          partnerLogo={edition.partnerLogo}
          iframeSrc={edition.screenPath}
          cameraEasing={(t) => (t <= 0 ? 0 : t >= 1 ? 1 : 1 - 2 ** (-6 * t))}
          camEndYOffset={0.15}
        />
      </div>
    </div>
    </div>
  );
}
